import React from 'react';
import { Link } from 'react-router-dom';
import { Vote, Award, Users } from 'lucide-react';
import { CONFERENCE } from '../mock';

function Group({ icon: Icon, title, items, testId }) {
  if (!items.length) return null;
  return (
    <div className="mt-6" data-testid={testId}>
      <div className="font-heading text-xs tracking-widest text-gold mb-2 inline-flex items-center gap-1.5"><Icon size={14} /> {title}</div>
      <div className="flex flex-wrap gap-2">
        {items.map((u) => <span key={u} className="border border-gold/40 bg-cbtu-black/50 text-cbtu-cream text-sm px-3 py-1 rounded-sm">{u}</span>)}
      </div>
    </div>
  );
}

export const ElectionReminder = ({ className = '' }) => (
  <Link to="/voter-registration" className={`flex items-start gap-3 rounded-md border-2 border-gold/70 bg-[#0c1c40] hover:bg-[#13285a] transition-colors p-4 ${className}`} data-testid="recap-election-reminder">
    <Vote size={26} className="text-gold shrink-0 mt-0.5" />
    <div>
      <div className="font-display text-xl md:text-2xl text-cbtu-cream leading-tight">ELECTION DAY IS <span className="gold-text-fill">TUESDAY, NOVEMBER 3</span></div>
      <p className="text-cbtu-text/90 text-sm mt-1">Didn&apos;t early vote? Get to the polls, and take a friend, a coworker and every registered voter in your house. Let&apos;s turn out Region III!</p>
    </div>
  </Link>
);

export const ConferenceRecap = () => {
  const { unions, sponsors } = CONFERENCE.recap;
  return (
    <div data-testid="conference-recap">
      <div className="chip mb-4 inline-block">THANK YOU, REGION III</div>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95] mb-4">
        <span className="gold-text-fill">THANK YOU</span><br />
        <span className="text-cbtu-cream">FOR A SUCCESSFUL</span><br />
        <span className="gold-text-fill">CONFERENCE</span>
      </h1>
      <p className="text-cbtu-text/90 text-base md:text-lg leading-relaxed max-w-2xl">
        Thank you to every union, sponsor, vendor, volunteer and attendee who helped make the 2026 CBTU Region III Regional Conference in Jacksonville a success. Together we showed that working people united can never be defeated.
      </p>
      <p className="font-serif-script text-xl text-cbtu-cream mt-3">“{CONFERENCE.theme}”</p>
      <p className="text-cbtu-text/90 text-sm md:text-base mt-4 max-w-2xl" data-testid="recap-keynote">A special thank you to our banquet keynote speaker, <span className="text-gold font-semibold">Phyllis Lucy</span>, daughter of CBTU Founder William “Bill” Lucy.</p>
      <Group icon={Users} title="UNIONS REPRESENTED" items={unions} testId="recap-unions" />
      <div className="mt-6" data-testid="recap-sponsors">
        <div className="font-heading text-xs tracking-widest text-gold mb-2 inline-flex items-center gap-1.5"><Award size={14} /> THANK YOU TO OUR SPONSORS</div>
        <div className="space-y-2">
          {sponsors.map((s) => (
            <div key={s.tier} className="text-sm" data-testid={`recap-sponsor-tier-${s.tier.toLowerCase().replace(/\s+/g, '-')}`}>
              <span className="font-heading tracking-widest text-gold-bright mr-2">{s.tier.toUpperCase()}:</span>
              <span className="text-cbtu-cream">{s.names.join(' · ')}</span>
            </div>
          ))}
        </div>
      </div>
      <ElectionReminder className="mt-8" />
    </div>
  );
};
